module.exports = "<p>\n  failed-page works!\n</p>\n"